import React, { Component } from "react"
import styles from "../../css/items.module.css"
import Project from "./Project"
import Title from "../Title"

export default class ProjectList extends Component {
  state = {
    projects: [],
    sortedProjects: [],
  }

  componentDidMount() {
    this.setState({
      projects: this.props.tours.edges,
      sortedProjects: this.props.tours.edges,
    })
  }

  render() {
    return (
      <section className={styles.tours}>
        <Title title="My" subtitle="Projects" />
        <div className={styles.center}>
          {this.state.sortedProjects.map(({ node }) => {
            return <Project key={node.contentful_id} tour={node} />
          })}
        </div>
      </section>
    )
  }
}
